import { all, call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { loadEntities, updateEntity, deleteEntity, LOGOUT_ACTION_TYPES } from 'helpers/utilHelpers';
import {
  LOAD_NOTIFICATIONS,
  VIEW_NOTIFICATION,
  VIEW_ALL_NOTIFICATION,
  DELETE_NOTIFICATION,
  SUBSCRIBE_NEW_FEED,
  UNSUBSCRIBE_NEW_FEED,
} from 'constants/ActionTypes';
import { SOCKET } from 'constants/SocketConstants';
import { appendNewFeedSocket } from 'actions/ui/notificationDrawerActions';
import SocketService from 'services/SocketService';
import { isMobile } from 'react-device-detect';
import { backendUrl } from 'util/config';
import { getSettingByKey } from 'selectors/settingsSelectors';
import { NOTIFICATION_PANEL } from 'constants/SettingConstants';

const socketInstance = SocketService.Instance;

function* loadNotifications() {
  yield takeEvery(LOAD_NOTIFICATIONS, loadEntities);
}

function* viewNotification() {
  yield takeEvery(VIEW_NOTIFICATION, updateEntity);
}

function* deleteNotification() {
  yield takeEvery(DELETE_NOTIFICATION, deleteEntity);
}

function* viewAllNotification() {
  yield takeEvery(VIEW_ALL_NOTIFICATION, updateEntity);
}

function* subscribeNewFeed() {
  const audio = new Audio(backendUrl + '/sound/noty.mp3');
  audio.volume = 0.4;

  while (true) {
    yield take(SUBSCRIBE_NEW_FEED);

    const channel = yield call(socketInstance.onSubscribe, SOCKET.newFeed);
    const task = yield takeEvery(channel, function*(data) {
      yield put(appendNewFeedSocket(data));
      const settings = yield select((state) => getSettingByKey(state, { settingKey: NOTIFICATION_PANEL }));
      const notificationSound = settings?.get('notificationSound') !== false;
      if (isMobile || !notificationSound) {
        return;
      }

      try {
        audio.play();
      } catch (error) {
        console.log(error);
      }
    });

    yield take([...LOGOUT_ACTION_TYPES, UNSUBSCRIBE_NEW_FEED]);

    channel.close();
    yield cancel(task);

    yield call(socketInstance.onUnsubscribe, SOCKET.newFeed);
  }
}

export default function* rootSaga() {
  yield all([
    fork(loadNotifications),
    fork(viewNotification),
    fork(viewAllNotification),
    fork(deleteNotification),
    fork(subscribeNewFeed),
  ]);
}
